<div class="panel panel--components">
  <div class="panel__header">
    

      <mat-form-field class="actionType-full-width">
        <mat-select placeholder="{{'Action Type' | translate | async}}" [(ngModel)]="actionTypeAuto" (selectionChange)="filterByActionType()" >
          <mat-option [value]="option.action_type_auto" *ngFor="let option of actionTypeList">
            {{option.action_description }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-select placeholder="{{'Side' | translate | async}}" [(ngModel)]="side" (selectionChange)="filterBySide()" name="side_">
          <mat-option *ngFor="let option of sideList" [value]="option" >
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-select placeholder="{{'Component Type' | translate | async}}" [(ngModel)]="componentType" (selectionChange)="filterByComponentType()" name="componentType_">
          <mat-option *ngFor="let com of componentTypesList" [value]="com" >
            {{ com }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <!--
      <mat-form-field class="example-full-width">
       <mat-select placeholder="Side Type">
          <mat-option *ngFor="let option of actionTypeList" [value]="option.action_type_auto" [(ngModel)]="actionTypeAuto" (selectionChange)="filterByActionType()" name="sideType_">
            {{ option.action_description }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      

      <mat-form-field>
        <input 
        name="start_Date"
        #start_Date="ngModel" 
        [(ngModel)]="startDate"
        matInput [matDatepicker]="startDatepicker" placeholder="{{'Start Date' | translate | async}}" (dateChange)="StartDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatepicker></mat-datepicker>
      </mat-form-field>
      

      <mat-form-field>
        <input 
        name="end_Date"
        #start_Date="ngModel" 
        [(ngModel)]="endDate"
        matInput [matDatepicker]="endDatepicker" placeholder="{{'End Date' | translate | async}}" (dateChange)="EndDateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatepicker></mat-datepicker>
      </mat-form-field>

      <button mat-raised-button (click)="refreshList()"><span class="material-icons button__icon">refresh</span><span>{{'REFRESH' | translate | async}}</span></button>

    
    <button mat-raised-button color="warn" (click)="DownloadCSVFile()"><span class="material-icons button__icon">save_alt</span></button>
  </div>

  <div class="panel panel--components">
    <div class="panel__header">
      
      <div class="checkbox-row">
        {{'Display Columns for' | translate | async}}:
        <mat-checkbox [checked]="ActionDesc" (change)="ShowHideTableColumn(1)">
          {{ 'Action Date' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="SMU" (change)="ShowHideTableColumn(2)">
          {{ 'SMU' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="LTD" (change)="ShowHideTableColumn(3)">
          {{ 'LTD' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="DOE" (change)="ShowHideTableColumn(13)">
          {{ 'DOE' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="LhChain" (change)="ShowHideTableColumn(4)">
          {{ 'L/H Chain CMU' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="RhChain" (change)="ShowHideTableColumn(5)">
          {{ 'R/H Chain CMU' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="Side" (change)="ShowHideTableColumn(6)">
          {{ 'Side' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="Pos" (change)="ShowHideTableColumn(7)">
          {{ 'Pos' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="ActionDescCol" (change)="ShowHideTableColumn(8)">
          {{ 'Action Desc' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="Comment" (change)="ShowHideTableColumn(9)">
          {{ 'Comment' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="EnteredBy" (change)="ShowHideTableColumn(10)">
          {{ 'Entered By' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="EnteredDate" (change)="ShowHideTableColumn(11)">
          {{ 'Entered Date' | translate | async }}
        </mat-checkbox>

        <mat-checkbox [checked]="JobSite" (change)="ShowHideTableColumn(12)">
          {{ 'Jobsite' | translate | async }}
        </mat-checkbox>
      </div>
    </div>
  
    <div class="panel__content no-padding">
      
    <div style="display: flex;flex-direction: column;" *ngIf="actionHistoryList != null && actionHistoryList.length > 0">
      <div>
        
        <table id="historyTable">
          <tr>
            <!--When a header is clicked, run the sortTable function, with a parameter, 0 for sorting by names, 1 for sorting by country:-->
            <!--<th *ngIf="ActionDesc" (click)="sortTable(0)" [ngClass]="changeArrow(0)">Action Date</th>
  <th *ngIf="SMU" (click)="sortTable(1)" [ngClass]="changeArrow(1)" style="width: 100px">SMU</th>
  <th *ngIf="LTD" (click)="sortTable(2)"  [ngClass]="changeArrow(2)" style="width: 100px">LTD</th>
  <th (click)="sortTable(3)"  [ngClass]="changeArrow(3)" style="width: 100px" *ngIf="EnableDistTravelledTracking && DOE">DOE ({{userUOD}})</th>
  <th *ngIf="LhChain" (click)="sortTable(4)" [ngClass]="changeArrow(4)" style="width: 100px">L/H Chain CMU</th>
  <th *ngIf="RhChain" (click)="sortTable(5)" [ngClass]="changeArrow(5)" style="width: 100px">R/H Chain CMU</th>
  <th *ngIf="Side" (click)="sortTable(6)"  [ngClass]="changeArrow(6)">Side</th>
  <th *ngIf="Pos" (click)="sortTable(7)" [ngClass]="changeArrow(7)">Pos</th>
  <th *ngIf="ActionDescCol" (click)="sortTable(8)" [ngClass]="changeArrow(8)">Action Desc</th>
  <th *ngIf="Comment" (click)="sortTable(9)"  [ngClass]="changeArrow(9)">Comment</th>
  <th *ngIf="EnteredBy" (click)="sortTable(10)"  [ngClass]="changeArrow(10)">Entered By</th>
  <th *ngIf="EnteredDate" (click)="sortTable(11)"  [ngClass]="changeArrow(11)">Entered Date</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Total <br>Cost</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Chain <br>Cost</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Rolling <br>Stock Cost</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Frame <br>Cost</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Segment <br>Cost</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Running <br>Cost</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Cost / <br> Hour</th>
  <th  (click)="sortTable(12)"  [ngClass]="changeArrow(12)">Cost / <br> Km</th>
  <th *ngIf="JobSite" (click)="sortTable(13)"  [ngClass]="changeArrow(13)">Jobsite</th>-->
            <th *ngIf="ActionDesc" (click)="sortTable('event_date')" [ngClass]="changeArrow('event_date')">
              {{ 'Action Date' | translate | async }}
            </th>

            <th *ngIf="SMU" (click)="sortTable('equipment_smu')" [ngClass]="changeArrow('equipment_smu')" style="width: 100px">
              {{ 'SMU' | translate | async }}
            </th>

            <th *ngIf="LTD" (click)="sortTable('equipment_ltd')" [ngClass]="changeArrow('equipment_ltd')" style="width: 100px">
              {{ 'LTD' | translate | async }}
            </th>

            <th (click)="sortTable('DOE')" [ngClass]="changeArrow('DOE')" style="width: 100px" *ngIf="EnableDistTravelledTracking && DOE">
              {{ 'DOE' | translate | async }} ({{userUOD}})
            </th>

            <th *ngIf="LhChain" (click)="sortTable('L_ChainCMU')" [ngClass]="changeArrow('L_ChainCMU')" style="width: 100px">
              {{ 'L/H Chain CMU' | translate | async }}
            </th>

            <th *ngIf="RhChain" (click)="sortTable('R_ChainCMU')" [ngClass]="changeArrow('R_ChainCMU')" style="width: 100px">
              {{ 'R/H Chain CMU' | translate | async }}
            </th>

            <th *ngIf="Side" (click)="sortTable('side')" [ngClass]="changeArrow('side')">
              {{ 'Side' | translate | async }}
            </th>

            <th *ngIf="Pos" (click)="sortTable('pos')" [ngClass]="changeArrow('pos')">
              {{ 'Pos' | translate | async }}
            </th>

            <th *ngIf="ActionDescCol" (click)="sortTable('action_name')" [ngClass]="changeArrow('action_name')">
              {{ 'Action Desc' | translate | async }}
            </th>

            <th *ngIf="Comment" (click)="sortTable('comment')" [ngClass]="changeArrow('comment')">
              {{ 'Comment' | translate | async }}
            </th>

            <th *ngIf="EnteredBy" (click)="sortTable('entry_user_name')" [ngClass]="changeArrow('entry_user_name')">
              {{ 'Entered By' | translate | async }}
            </th>

            <th *ngIf="EnteredDate" (click)="sortTable('entry_date')" [ngClass]="changeArrow('entry_date')">
              {{ 'Entered Date' | translate | async }}
            </th>

            <th (click)="sortTable('totalCost')" [ngClass]="changeArrow('totalCost')">
              {{ 'Total Cost' | translate | async }}
            </th>

            <th (click)="sortTable('ChainCost')" [ngClass]="changeArrow('ChainCost')">
              {{ 'Chain Cost' | translate | async }}
            </th>

            <th (click)="sortTable('RollerStockCost')" [ngClass]="changeArrow('RollerStockCost')">
              {{ 'Rolling Stock Cost' | translate | async }}
            </th>

            <th (click)="sortTable('FrameCost')" [ngClass]="changeArrow('FrameCost')">
              {{ 'Frame Cost' | translate | async }}
            </th>

            <th (click)="sortTable('SegmentCost')" [ngClass]="changeArrow('SegmentCost')">
              {{ 'Segment Cost' | translate | async }}
            </th>

            <th (click)="sortTable('RunningCost')" [ngClass]="changeArrow('RunningCost')">
              {{ 'Running Cost' | translate | async }}
            </th>

            <th (click)="sortTable('CostPerHour')" [ngClass]="changeArrow('CostPerHour')">
              {{ 'Cost/Hour' | translate | async }}
            </th>

            <th (click)="sortTable('CostPerKm')" [ngClass]="changeArrow('CostPerKm')">
              {{ 'Cost/Km' | translate | async }}
            </th>

            <th *ngIf="JobSite" (click)="sortTable('ActionJobsite')" [ngClass]="changeArrow('ActionJobsite')">
              {{ 'Jobsite' | translate | async }}
            </th>
            <th *ngIf="allowEditAction && hasLastAction">
              {{ 'Edit Action' | translate | async }}
            </th>
          </tr>
          <tr *ngFor ="let data of sortedData">
            <td class="tdClass" *ngIf="ActionDesc" >{{data.event_date}}</td>
            <td class="tdClass" *ngIf="SMU" style="width: 100px">{{data.equipment_smu}}</td>
            <td class="tdClass" *ngIf="LTD" style="width: 100px">{{data.equipment_ltd}}</td>
            <td class="tdClass" style="width: 100px" *ngIf="EnableDistTravelledTracking && DOE">{{convertDistanceKmToMi(data.DOE)}}</td>
            <td class="tdClass" *ngIf="LhChain"style="width: 100px">{{data.L_ChainCMU}}</td>
            <td class="tdClass" *ngIf="RhChain"style="width: 100px">{{data.R_ChainCMU}}</td>
            <td class="tdClass" *ngIf="Side">{{data.side != null ? data.side == 2 ? "Right" : data.side == 1 ? "Left" : "" : ""}}</td>
            <td class="tdClass"*ngIf="Pos">{{data.pos}}</td>
            <td class="tdClass" *ngIf="ActionDescCol">{{data.action_name}} <span *ngIf="data.action_type_auto==10702 || data.action_type_auto==10602">{{data.ReplacedPos}}</span></td>
            <td class="tdClass" *ngIf="Comment"style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;max-width: 200px; cursor: pointer;" title="{{data.comment}}">{{data.comment}}</td>
            <td class="tdClass"*ngIf="EnteredBy">{{data.entry_user_name}}</td>
            <td class="tdClass"*ngIf="EnteredDate">{{data.entry_date}}</td>
            <td class="tdClass" ><span *ngIf="data.action_type_auto!=32 && data.action_type_auto!=37 && data.action_type_auto!=41 && data.action_type_auto!=33 && data.action_type_auto!=44" (click)="EditComponentData(data.history_id)" style="cursor: pointer;"> {{data.totalCost | currency}}</span> </td>
            <td class="tdClass" ><span *ngIf="data.action_type_auto!=32 && data.action_type_auto!=37 && data.action_type_auto!=41 && data.action_type_auto!=33 && data.action_type_auto!=44" (click)="EditComponentData(data.history_id)" style="cursor: pointer;"> {{data.ChainCost | currency}}</span></td>
            <td class="tdClass" ><span *ngIf="data.action_type_auto!=32 && data.action_type_auto!=37 && data.action_type_auto!=41 && data.action_type_auto!=33 && data.action_type_auto!=44" (click)="EditComponentData(data.history_id)" style="cursor: pointer;"> {{data.RollerStockCost | currency}}</span></td>
            <td class="tdClass" ><span *ngIf="data.action_type_auto!=32 && data.action_type_auto!=37 && data.action_type_auto!=41 && data.action_type_auto!=33 && data.action_type_auto!=44" (click)="EditComponentData(data.history_id)" style="cursor: pointer;"> {{data.FrameCost | currency}}</span></td>
            <td class="tdClass" ><span *ngIf="data.action_type_auto!=32 && data.action_type_auto!=37 && data.action_type_auto!=41 && data.action_type_auto!=33 && data.action_type_auto!=44" (click)="EditComponentData(data.history_id)" style="cursor: pointer;"> {{data.SegmentCost | currency}}</span></td>
            <td class="tdClass" ><span> {{data.RunningCost | currency}}</span></td>
            <td class="tdClass" ><span>${{data.CostPerHour| number : '1.2-2'}}</span></td>
            <td class="tdClass" ><span>${{data.CostPerKm | number : '1.2-2'}}</span></td>
            <td class="tdClass" *ngIf="JobSite">{{data.ActionJobsite}} </td>
            <td class="tdClass" style="text-align: center;" *ngIf="hasLastAction && allowEditAction">
              <span *ngIf="data.IsLastAction">
                <i class="material-icons text-container__edit" style="cursor: pointer;"
                   (click)="editAction(data)">edit</i>
              </span>
            </td>
          </tr>
        </table>
      </div>
      <div class="total_cost_view">
        <span style="font-size: 16px;font-weight: bold;
        margin-right: 30px;">
          {{'TOTAL' | translate | async}}</span>
        <span style="font-size: 16px;font-weight: bold;">{{totalCost | currency
          }}
        </span>
      </div>
    </div>
  </div>
</div>
